<template>
  <main class="content">
      <div class="row">
          <h1>
              Add new Wall
          </h1>
      </div>
      <form novalidate v-on:submit.prevent="addWall" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
          <fieldset class="form--item">
              <label class="label" for="">
                  Name:
              </label>
              <div class="input_text" id="name">
                  <input name="" v-model="wall.name" required placeholder="Write a wall name" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  City:
              </label>
              <div class="input_text" id="cityId">
                  <v-select v-model="cityId" required :searchable="false" placeholder="Select a city" :options="cities"></v-select>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Address:
              </label>
              <div class="input_text" id="address">
                  <input name="" v-model="wall.address" placeholder="Write an address" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Zip code:
              </label>
              <div class="input_text" id="zipcode">
                  <input name="" v-model="wall.zipcode" placeholder="Write a zip code" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Agent email address:
              </label>
              <div class="input_text" id="agentEmail">
                  <input name="" v-model="agentEmail" placeholder="Write an email address" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="picture">
                  Picture:
              </label>
              <div class="form--item_img-wrapper">
                <div class="form--item_img" id="preview_image"></div>
                <label class="input_file" for="picture"  id="picture_choose">
                    <span class="btn btn_grey">
                        Choose file
                    </span>
                    <input v-on:change="setPicture" required id="picture" name="picture" type="file"/>
                </label>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  About Wall:
              </label>
              <div class="input_text input_text_long" id="wallDescription">
                  <textarea name="" v-model="wall.wallDescription" placeholder="Write something about the wall" type="text">
                  </textarea>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Add Wall Location pin:
              </label>
              <div class="location--wrapper">
                  <gmap-map
                    :center="wall.location"
                    :zoom="16"
                    map-type-id="terrain"
                    style="width: 500px; height: 300px"
                  >
                    <gmap-marker
                      :position="wall.location"
                      :clickable="true"
                      :draggable="true"
                      @dragend="dragend($event)"
                      :icon="'static/images/gm_pin.png'"
                    ></gmap-marker>

                  </gmap-map>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Create new password
              </label>
              <div class="input_text" id="password">
                  <input name="" v-model="wall.password" placeholder="Choose a password" type="password"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Screen saver:
              </label>
              <div class="input_text" id="screensaverId">
                  <v-select v-model="screensaverId" required :searchable="false" placeholder="Pick a screensaver" :options="screensavers"></v-select>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Webcams:
              </label>
              <div class="inputGroup">
                  <label class="inputGroup--label" for="input8">
                      Webcam 1
                  </label>
                  <div class="input_text">
                      <input id="input8" v-model="webcam_1" name="" placeholder="Paste a URL link from Ustream" type="text"/>
                  </div>
              </div>
              <div class="inputGroup">
                  <label class="inputGroup--label" for="input9">
                      Webcam 2
                  </label>
                  <div class="input_text">
                      <input id="input9" v-model="webcam_2" name="" placeholder="Paste a URL link from Ustream" type="text"/>
                  </div>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Basis price per 6 seconds:
              </label>
              <div class="input_text" id="basePricing">
                  <input name="" v-model="wall.basePricing" placeholder="1$" type="text"/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Princing blocks:
                  <span>
                      (Any timeslot which is not covered will apply the basis price).
                  </span>
              </label>
              <div v-for="block in wall.pricingModifiers">
                <div class="input_text">
                    <input name="" @click="editPriceBlock(block)" class="pointer" type="text" :value="block.formatted_value" readonly="true" />
                </div>
                <div class="row7">
                    <button class="btn btn_half btn_blueLight u-fleft" @click="editPriceBlock(block)" type="button">
                        Edit
                    </button>
                    <button class="btn btn_half btn_red u-fleft" @click="deletePriceBlock(block)" type="button">
                        Delete
                    </button>
                </div>
              </div>
              <div class="row7">
                  <button class="btn row7--add u-fleft" @click="togglePriceBlock()" type="button">
                      Add new pricing block
                  </button>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Recurring blocked timeslots:
              </label>
              <div v-for="block in wall.recurringBlockedTimeslots">
                <div class="input_text">
                    <input name="" @click="editRecurringBlockedTimeslotBlock(block)" class="pointer" type="text" :value="block.formatted_value" readonly="true" />
                </div>
                <div class="row7">
                    <button class="btn btn_half btn_blueLight u-fleft" @click="editRecurringBlockedTimeslotBlock(block)" type="button">
                        Edit
                    </button>
                    <button class="btn btn_half btn_red u-fleft" @click="deleteRecurringBlockedTimeslotBlock(block)" type="button">
                        Delete
                    </button>
                </div>
              </div>
              <div class="row7">
                  <button class="btn row7--add u-fleft" @click="toggleRecurringBlockedTimeslotBlock()" type="button">
                      Add new recurring blocked timeslot
                  </button>
              </div>
          </fieldset>
          <div class="row">
              <button class="btn btn_blue" type="submit">
                  Add Wall
              </button>
          </div>
      </form>
      <price :visible.sync="priceVisible" :block="block"></price>
      <recurringBlockedTimeslot :visible.sync="recurringBlockedTimeslotVisible" :block="block"></recurringBlockedTimeslot>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
  import * as HttpService from '../../services/http.service'
  import vSelect from "vue-select"
  import Price from '../Modals/modal_price';
  import RecurringBlockedTimeslot from '../Modals/modal_recurring_blocked_timeslot';
  import Message from '../Message.vue'
  import Loading from '../Loading.vue'

  import * as ValidateForm from '../../mixins/validate-form.mixin';
  export default {
    name: 'AddWalls',
    components: {
      vSelect,
      Price,
      RecurringBlockedTimeslot,
      Loading,
      Message
    },
    mixins: [ValidateForm],
    data() {
      return {
        wall: {
          location: {
            lat: 40.7128,
            lng: -74.0059
          },
          webcams: [],
          pricingModifiers: [],
          recurringBlockedTimeslots: []
        },
        agentEmail: '',
        required_fields: [{
            'attribute': 'wall.name',
            'message': 'Name is missing',
            'id': 'name'
          },
          {
            'attribute': 'cityId',
            'message': 'City is missing',
            'id': 'cityId'
          },
          {
            'attribute': 'wall.address',
            'message': 'Address is missing',
            'id': 'address'
          },
          {
            'attribute': 'wall.zipcode',
            'message': 'Zipcode is missing',
            'id': 'zipcode'
          },
          {
            'attribute': 'agentEmail',
            'message': 'Agent email is missing',
            'id': 'agentEmail'
          },
          {
            'attribute': 'wall.wallDescription',
            'message': 'Description is missing',
            'id': 'wallDescription'
          },
          {
            'attribute': 'wall.password',
            'message': 'Password is missing',
            'id': 'password'
          },
          {
            'attribute': 'wall.basePricing',
            'message': 'Base pricing is missing',
            'id': 'basePricing'
          },
          {
            'attribute': 'screensaverId',
            'message': 'ScreenSaver is missing',
            'id': 'screensaverId'
          },
          {
            'attribute': 'picture.name',
            'message': 'Picture is missing',
            'id': 'picture_choose'
          },
        ],
        cityId: '',
        screensaverId: '',
        priceVisible: false,
        recurringBlockedTimeslotVisible: false,
        loadingVisible: false,
        block: {},
        picture: {},
        webcam_1: '',
        webcam_2: '',
        screensavers: [],
        cities: []
      }
    },
    created() {
      var self = this;
      HttpService.index('screensavers', {}, function(response, error) {
        self.screensavers = response.result.data;

        self.screensavers = self.screensavers.map(item => {
          return {
            value: item.id,
            label: item.videoDetails.title
          }
        });
      });

      HttpService.index('cities', {}, function(response, error) {
        self.cities = response.result.data;
        self.cities = self.cities.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        });
      });
    },
    methods: {
      togglePriceBlock() {
        this.priceVisible = !this.priceVisible;
        this.block = {};
      },
      deletePriceBlock(block) {
        this.wall.pricingModifiers = this.wall.pricingModifiers.filter(function(item) {
          return item.id != block.id
        });
        this.block = {};
      },
      editPriceBlock(block) {
        this.block = block;
        this.priceVisible = true;
      },
      addPriceBlock(block) {
        let index = this.wall.pricingModifiers.find(item => item.id == block.id);
        if (index) {
          for (var i = this.wall.pricingModifiers.length - 1; i >= 0; i--) {
            if (this.wall.pricingModifiers[i].id == block.id) {
              this.wall.pricingModifiers[i] = block;
              break;
            }
          }
        } else {
          this.wall.pricingModifiers.push(block);
        }
        this.priceVisible = false;
        this.block = {};
      },
      toggleRecurringBlockedTimeslotBlock() {
        this.recurringBlockedTimeslotVisible = !this.recurringBlockedTimeslotVisible;
        this.block = {};
      },
      deleteRecurringBlockedTimeslotBlock(block) {
        this.wall.recurringBlockedTimeslots = this.wall.recurringBlockedTimeslots.filter(function(item) {
          return item.id != block.id
        });
        this.block = {};
      },
      editRecurringBlockedTimeslotBlock(block) {
        this.block = block;
        this.recurringBlockedTimeslotVisible = true;
      },
      addRecurringBlockedTimeslotBlock(block) {
        let index = this.wall.recurringBlockedTimeslots.find(item => item.id == block.id);
        if (index) {
          for (var i = this.wall.recurringBlockedTimeslots.length - 1; i >= 0; i--) {
            if (this.wall.recurringBlockedTimeslots[i].id == block.id) {
              this.wall.recurringBlockedTimeslots[i] = block;
              break;
            }
          }
        } else {
          this.wall.recurringBlockedTimeslots.push(block);
        }
        this.recurringBlockedTimeslotVisible = false;
        this.block = {};
      },
      dragend(e) {
        this.wall.location = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        };
      },
      setPicture(e) {
        var files = e.target.files || e.dataTransfer.files;
        this.picture = files[0];
        var reader = new FileReader();

        reader.onload = function(e) {
          $('#preview_image').css('background-image', 'url(' + e.target.result + ')').show();
        }
        reader.readAsDataURL(this.picture);
      },
      addWall() {
        var self = this;
        self.wall.webcams = []
        if (this.validate()) {
          self.wall.cityId = self.cityId.value || self.wall.cityId;
          self.wall.screensaverId = self.screensaverId.value || self.wall.screensaverId;
          if (self.webcam_1) {
            self.wall.webcams.push({ originalLink: self.webcam_1 });
          }

          if (self.webcam_2) {
            self.wall.webcams.push({ originalLink: self.webcam_2 });
          }
        } else {
          return false;
        }

        // Format recurring blocked timeslots
        var weeklyBlocking = {};
        for (var i in self.wall.recurringBlockedTimeslots) {
          let slot = self.wall.recurringBlockedTimeslots[i];
          if (!weeklyBlocking.hasOwnProperty(slot.dayId.toString())) {
            weeklyBlocking[slot.dayId.toString()] = [];
          }
          weeklyBlocking[slot.dayId.toString()].push({
            startSlot: parseInt(slot.startSlot),
            endSlot: parseInt(slot.endSlot)
          });
        }
        self.wall.weeklyBlocking = weeklyBlocking;

        var data = new FormData();
        for (var i in this.wall) {
          let val = this.wall[i];
          if (typeof val == "object")
            val = JSON.stringify(this.wall[i]);
          data.append(i, val);
        }
        data.append('picture', this.picture);

        HttpService.post('walls', data, function(response, error) {
          if (error) {
            self.errorMessage = error.message;
            self.loadingVisible = false;
          } else {
            self.updateAgent(response.result.id);
          }
        });
      },
      updateAgent(wallId){
        var self = this;
        const body = {
          agentEmail: self.agentEmail
        }
        HttpService.update('agents/setwall/' + wallId, '', body, function(response, error) {
          if (error) {
            self.errorMessage = error.message;
          } else {
            self.$router.push({
              name: 'Walls'
            });
          }
          self.loadingVisible = false;
        });
      }
    }
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// AddWalls.vue?b3d33a7c